import { AuditServicePayload } from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces';
import { hostsConfig } from '../utils';

export class AuditServiceDao {
  static async postAuditService(
    env: Environment,
    payload: AuditServicePayload
  ): Promise<null> {
    const url = `${hostsConfig[env].auditService}/v1/audit/logs`;
    const { data } = await axios.post(url, payload);

    return data;
  }
}
